import axios from "axios";

export default {
	data: {
		member: {},
		imageLoaded: false,
		modalParams: {},
		activeModal: null,
		newProfileTooltip: {
			content:
				'<h6 class="title is-6 text-bold">Show off your engineering powers</h6>' +
				'<p class="tooltip__paragraph">Edit your public profile to control how engineers see you in the Community.</p>'
		}
	},
	computed: {
		opentoworkStatus() {
			return Grabcad.opentoworkStore.state.opentoworkStatus;
		}
	},
	methods: {
		deactivateModal: function() {
			this.activeModal = null;
		},
		showAbout: function(about) {
			this.modalParams = { about: about };
			this.activeModal = "about-modal";
		},
		reportMember: function(memberId) {
			this.modalParams = {
				reportableId: memberId,
				reportable: "member_id",
				title: "Report member"
			};
			this.activeModal = "report-modal";
		},
		markTipAsSeen: function() {
			axios.post("/profile/tooltip");
		}
	}
};
